import React from 'react';
import { Field, Form } from 'formik';
import FormikInputField from 'components/Fields/FormikInputField';
import { Button, Col, Row } from 'reactstrap';
import CardWithTitle from 'components/CardWithTitle';
import S3FileUploadField from 'components/S3FileUploadField';
import LoadingButton from 'components/common/LoadingButton';
import EditUploadWrapper from 'components/EditUploadWrapper';
import SubCategorySelectField from 'components/SubCategorySelectField';
import { ADD_EDIT_CONSTANT, dynamicButtonHeading } from 'utils/constants';
import GradeTypeSelectField from 'components/GradeTypeSelectField';

const AddEditCategoryGradeForm = (props) => {
  const {
    handleSubmit,
    isSubmitting,
    isValid,
    dirty,
    toggleAddRecord,
    setFieldValue,
    values,
    type,
  } = props;
  const handleCancel = (val) => {
    setFieldValue(val, '');
  };
  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle title="">
        <Row>
          <Col sm={5}>
            <Field
              label="Manufacturer"
              name="manufacturer"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>

          <Col sm={5}>
            <SubCategorySelectField required />
          </Col>

          <Col sm={5}>
            <Field
              label="Grade Name"
              name="name"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>
          <Col sm={5}>
            <Field
              label="MFI"
              name="mfi"
              type="text"
              component={FormikInputField}
            />
          </Col>
        </Row>
      </CardWithTitle>
      {/* <CardWithTitle title="">
        <S3FileUploadField
          label="Grade Image"
          name="gradeImage"
          pathUrl="images/grades/grade_images"
        />
      </CardWithTitle> */}
      <CardWithTitle title="">
        <Row>
          <Col sm={5}>
            <Field
              label="Description"
              name="description"
              type="text"
              component={FormikInputField}
            />
          </Col>
          <Col sm={5}>
            <GradeTypeSelectField required />
          </Col>

          <Col sm={5}>
            <Field
              label="Application"
              name="applications"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>
          <Col sm={5}>
            <Field
              label="Polymer Sector Manufacturer"
              name="productSubCategoryManufacturer"
              type="text"
              component={FormikInputField}
              required
            />
          </Col>
        </Row>
      </CardWithTitle>
      <CardWithTitle title="">
        {values?.photos ? (
          <EditUploadWrapper
            label="Description Image"
            name="photos"
            fileName={values.photos}
            handleCancel={() => handleCancel('photos')}
            required
          />
        ) : (
          <S3FileUploadField
            label="Description Image"
            name="photos"
            pathUrl="images/grades/photos"
            required
            containerName="public-assets"
          />
        )}
      </CardWithTitle>
      <CardWithTitle title="">
        {values?.specsSheet ? (
          <EditUploadWrapper
            label="Document"
            name="specsSheet"
            fileName={values.specsSheet}
            handleCancel={() => handleCancel('specsSheet')}
            required
          />
        ) : (
          <S3FileUploadField
            label="Document"
            name="specsSheet"
            pathUrl="images/grades/specsSheets"
            required
            containerName="public-assets"
          />
        )}
      </CardWithTitle>
      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={toggleAddRecord}
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={
            !isValid ||
            (type !== ADD_EDIT_CONSTANT.EDIT && !dirty) ||
            isSubmitting
          }
          color="warning"
          size="sm"
          type="submit"
        >
          {dynamicButtonHeading(type)}
        </LoadingButton>
      </div>
    </Form>
  );
};

export default AddEditCategoryGradeForm;
